import { AUTH_URL } from '@/constants/app'
import { currentLocale } from '@/i18n'
import { withLocale } from '@/i18n/shared-locale'
import { http } from '@/services/http'
import { useAuthStore } from '@/stores/auth.store'

/**
 * Ending a session, in the two shapes the app needs.
 *
 * A browser holds one logistics session whatever the role, and a customer holds a second one in the
 * shared auth app. Leaving the first alone made the next sign-in, as anyone, slide back into the
 * old account; leaving the second alone did the same for customers.
 */

/**
 * End the logistics session in this browser: the server forgets the token (best effort, it may
 * already be expired) and the stored session is cleared at once, without waiting for the answer.
 */
export function endSession(): void {
  const auth = useAuthStore()
  const token = auth.token

  if (token) {
    void http
      .post('/auth/logout', {}, { headers: { Authorization: `Bearer ${token}` } })
      .catch(() => undefined)
  }

  auth.clearSession()
}

/** The auth app's sign-out page, which returns to this app's front page once its session is gone. */
export function customerSignOutUrl(): string {
  return withLocale(
    `${AUTH_URL}/logout?redirect=${encodeURIComponent(`${window.location.origin}/`)}`,
    currentLocale(),
    window.location.origin
  )
}

/**
 * A customer signs out of both places: here, and the auth app that signed them in. Only clearing
 * this app's session left the auth app's open, so the next "sign in" from any page logged the same
 * customer straight back in.
 */
export function signOutCustomer(): void {
  endSession()
  window.location.assign(customerSignOutUrl())
}
